import React from 'react';

/** iOS-style toggle in violet. Controlled via `checked` + `onChange`. */
export function Switch({ checked = false, onChange, disabled = false, style = {} }) {
  return (
    <button
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => !disabled && onChange?.(!checked)}
      style={{
        width: 46, height: 28, flexShrink: 0,
        borderRadius: 'var(--ld-radius-pill)',
        border: 'none', padding: 3,
        background: checked ? 'var(--ld-primary)' : 'var(--ld-surface-top)',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        display: 'flex', alignItems: 'center',
        justifyContent: checked ? 'flex-end' : 'flex-start',
        transition: 'background var(--ld-transition-base) var(--ld-ease)',
        ...style,
      }}
    >
      <span style={{
        width: 22, height: 22, borderRadius: '50%', background: '#fff',
        boxShadow: '0 2px 5px rgba(25,20,15,0.2)',
        transition: 'transform var(--ld-transition-spring)',
      }} />
    </button>
  );
}
